__turbopack_context__.v({
  "lineLogo": "LineLogo-module__kU5q-a__lineLogo",
});
